module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-3-a745ebcc72b049cfc029a21e1603ac78.jpg";